// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.custom-procedures_modal-content_gpGU2 {
    width: 700px;
    margin: 50px auto; /* This modal is taller than most, reduce top margin */
}

.custom-procedures_body_Kv_MY {
    background: var(--ui-modal-background);
    padding: 1.5rem 2.25rem;
}

.custom-procedures_body_Kv_MY input[type="checkbox"],
.custom-procedures_body_Kv_MY input[type="radio"] {
    margin: 3px;
}

/* Blocks workspace for custom procedure declaration editor */

.custom-procedures_workspace_GChHs {
    min-height: 200px;
    position: relative;
}

.custom-procedures_workspace_GChHs .injectionDiv{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

.custom-procedures_workspace_GChHs .blocklySvg {
    background-color: var(--ui-primary);
}

/* Row of "card" buttons for modifying custom procedures */

.custom-procedures_options-row_aOcgo {
    display: flex;
    justify-content: space-between;
}

.custom-procedures_option-card_mbVK0 {
    background: var(--ui-white);
    border: 2px solid var(--ui-black-transparent);
    border-radius: 0.5rem;
    padding: calc(0.5rem * 2);
    text-align: center;
    flex-grow: 1;
    cursor: pointer;
    transition: all 0.2s;
    flex-basis: 100px;
}

.custom-procedures_option-card_mbVK0:hover {
    border: 2px solid var(--looks-secondary);
    box-shadow: 0px 0px 0px 4px var(--looks-transparent);
}

.custom-procedures_option-card_mbVK0 + .custom-procedures_option-card_mbVK0 {
    margin-left: 1rem;
}

.custom-procedures_option-icon_JR3Qb {
    max-height: 48px;
    margin-bottom: 0.5rem;
}

.custom-procedures_option-title_LQGE2 {
    font-weight: bold;
}

/* "Run without screen refresh" row */

.custom-procedures_checkbox-row_wLWGu {
    margin-top: 1rem;
}

/* Confirmation buttons at the bottom of the modal */

.custom-procedures_button-row_WVIOp {
    margin-top: 1rem;
    font-weight: bolder;
    text-align: right;
}

.custom-procedures_button-row_WVIOp button {
    border: 1px solid var(--ui-black-transparent);
    border-radius: 0.25rem;
    padding: 0.75rem 1rem;
    background: white;
    color: black;
    font-weight: bold;
    font-size: 0.85rem;
}

.custom-procedures_button-row_WVIOp button.custom-procedures_ok-button_gegBg {
    background: var(--looks-secondary);
    border: var(--looks-secondary);
    color: white;
}

[dir="ltr"] .custom-procedures_button-row_WVIOp button + button {
    margin-left: 0.5rem;
}

[dir="rtl"] .custom-procedures_button-row_WVIOp button + button {
    margin-right: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/custom-procedures/custom-procedures.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,YAAY;IACZ,iBAAiB,EAAE,sDAAsD;AAC7E;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;AACf;;AAEA,6DAA6D;;AAE7D;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;AACX;;AAEA;IACI,mCAAmC;AACvC;;AAEA,0DAA0D;;AAE1D;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;IAC7C,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,wCAAwC;IACxC,oDAAoD;AACxD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,qCAAqC;;AAErC;IACI,gBAAgB;AACpB;;AAEA,oDAAoD;;AAEpD;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,6CAA6C;IAC7C,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.modal-content {\n    width: 700px;\n    margin: 50px auto; /* This modal is taller than most, reduce top margin */\n}\n\n.body {\n    background: var(--ui-modal-background);\n    padding: 1.5rem 2.25rem;\n}\n\n.body input[type=\"checkbox\"],\n.body input[type=\"radio\"] {\n    margin: 3px;\n}\n\n/* Blocks workspace for custom procedure declaration editor */\n\n.workspace {\n    min-height: 200px;\n    position: relative;\n}\n\n.workspace :global(.injectionDiv){\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n\n.workspace :global(.blocklySvg) {\n    background-color: var(--ui-primary);\n}\n\n/* Row of \"card\" buttons for modifying custom procedures */\n\n.options-row {\n    display: flex;\n    justify-content: space-between;\n}\n\n.option-card {\n    background: var(--ui-white);\n    border: 2px solid var(--ui-black-transparent);\n    border-radius: 0.5rem;\n    padding: calc(0.5rem * 2);\n    text-align: center;\n    flex-grow: 1;\n    cursor: pointer;\n    transition: all 0.2s;\n    flex-basis: 100px;\n}\n\n.option-card:hover {\n    border: 2px solid var(--looks-secondary);\n    box-shadow: 0px 0px 0px 4px var(--looks-transparent);\n}\n\n.option-card + .option-card {\n    margin-left: 1rem;\n}\n\n.option-icon {\n    max-height: 48px;\n    margin-bottom: 0.5rem;\n}\n\n.option-title {\n    font-weight: bold;\n}\n\n/* \"Run without screen refresh\" row */\n\n.checkbox-row {\n    margin-top: 1rem;\n}\n\n/* Confirmation buttons at the bottom of the modal */\n\n.button-row {\n    margin-top: 1rem;\n    font-weight: bolder;\n    text-align: right;\n}\n\n.button-row button {\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: 0.25rem;\n    padding: 0.75rem 1rem;\n    background: white;\n    color: black;\n    font-weight: bold;\n    font-size: 0.85rem;\n}\n\n.button-row button.ok-button {\n    background: var(--looks-secondary);\n    border: var(--looks-secondary);\n    color: white;\n}\n\n[dir=\"ltr\"] .button-row button + button {\n    margin-left: 0.5rem;\n}\n\n[dir=\"rtl\"] .button-row button + button {\n    margin-right: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": `custom-procedures_modal-content_gpGU2`,
	"modalContent": `custom-procedures_modal-content_gpGU2`,
	"body": `custom-procedures_body_Kv_MY`,
	"workspace": `custom-procedures_workspace_GChHs`,
	"options-row": `custom-procedures_options-row_aOcgo`,
	"optionsRow": `custom-procedures_options-row_aOcgo`,
	"option-card": `custom-procedures_option-card_mbVK0`,
	"optionCard": `custom-procedures_option-card_mbVK0`,
	"option-icon": `custom-procedures_option-icon_JR3Qb`,
	"optionIcon": `custom-procedures_option-icon_JR3Qb`,
	"option-title": `custom-procedures_option-title_LQGE2`,
	"optionTitle": `custom-procedures_option-title_LQGE2`,
	"checkbox-row": `custom-procedures_checkbox-row_wLWGu`,
	"checkboxRow": `custom-procedures_checkbox-row_wLWGu`,
	"button-row": `custom-procedures_button-row_WVIOp`,
	"buttonRow": `custom-procedures_button-row_WVIOp`,
	"ok-button": `custom-procedures_ok-button_gegBg`,
	"okButton": `custom-procedures_ok-button_gegBg`
};
export default ___CSS_LOADER_EXPORT___;
